export class user {
  id: number;
  firstname: string;
  lastname: string;
  email: string;
  quality: string;  

}



// WEBPACK FOOTER //
// ./src/models/user.model.ts